namespace GeniuzPOS.InventoryReport {
    export interface IcReport08DtForm {
    }

    export class IcReport08DtForm extends Serenity.PrefixedContext {
        static formKey = 'InventoryReport.IcReport08Dt';
    }
}
